import Home from '@arcgis/core/widgets/Home';
import { Sketch } from 'cd-eft/utils/esriTypes';
import { action, observable } from 'mobx';
import { ProjectsStore } from './ProjectsStore';

const NULL_ANY: any = null; // helps get around strict type sense on POJO

class EFH2ProjectsStore extends ProjectsStore {
  constructor(private efh2Store: any) {
    super(efh2Store);
  }
}

export class EFH2Store {
  @observable projectsStore: EFH2ProjectsStore;
  todaysDate = new Date();
  @observable basicDataForm;
  @observable gisSessionExport;
  @observable gisModel;
  @observable homeWidget?: Home;
  @observable gisAoiGridData;
  @observable rainfallDischargeTable;
  @observable rainfallPlotData;
  @observable aoiContainsWatershed?: boolean;
  @observable aoiContainsFlowPath?: boolean;
  @observable hasValidWatershedPolygon?: boolean;
  @observable hasValidAoiPolygon?: boolean = true;
  @observable dlUrls;
  @observable rcnTable;
  @observable unitsAreAcres;
  @observable landUseCategorySelection;
  @observable rcnData;
  @observable velocityInputUpdated?: boolean = false;
  @observable tocManuallyUpdated?: boolean = false;
  @observable tocManuallyUpdatedComment?: string = "";

  constructor(private appStore: any) {
    this.projectsStore = new EFH2ProjectsStore(this);
    this.init();
  }

  @action reset() {
    this.init();
  }

  @action init() {
    this.initRainfallAndDrainage();
    this.gisSessionExport = '';
    this.gisModel = {
      map: null,
      mapView: null,
      workflowStep: null,
      gpSessionId: null,
      gpSessionData: {
        output_UPLOADED_DEM: NULL_ANY,
        layer_UPLOADED_DEM: NULL_ANY,

        output_USER_DEM: NULL_ANY,
        layer_USER_DEM: NULL_ANY,

        output_AOI_FEATURE: NULL_ANY,
        output_AOI_DEM: NULL_ANY,
        layer_AOI_RESULTS: NULL_ANY,

        output_SN_STREAMS: NULL_ANY,
        output_SN_CULVERTS: NULL_ANY,
        output_SN_FLOWDIR: NULL_ANY,
        layer_SN_RESULTS: NULL_ANY,

        output_WS_WATERSHED: NULL_ANY,
        output_WS_OUTLETS: NULL_ANY,
        output_WS_FLOWLENGTH: NULL_ANY,
        layer_WS_RESULTS: NULL_ANY,

        output_SAL_WATERSHED: NULL_ANY,
        result_soils: NULL_ANY,
        output_SAL_LANDUSE: NULL_ANY,
        layer_SAL_RESULTS: NULL_ANY,

        output_RCN_WATERSHED: NULL_ANY,
        output_RCN_SUBAREAS: NULL_ANY,
        layer_RCN_RESULTS: NULL_ANY,
      },
    };
    this.gisAoiGridData = [];
    this.aoiContainsWatershed = undefined;
    this.aoiContainsFlowPath = undefined;
    this.hasValidWatershedPolygon = undefined;
  }
  @action initRainfallAndDrainage() {
    this.basicDataForm = {
      client: '',
      state: '',
      county: '',
      latlongInfo: '',
      practice: '',
      user: '',
      createDate:
        this.todaysDate.getMonth() + 1 + '/' + this.todaysDate.getDate() + '/' + this.todaysDate.getFullYear(),
      drainageArea: 0,
      watershedLen: 0,
      timeC: 0,
      runoffCN: 0,
      watershedSlope: 0,
      dimUnitHydrog: 'Standard - 484',
      dimUnitHydrogID: 0,
      // rainfallType: '',
      // rainfallTypeID: '',
      // rainfallDist: '',
      // rainfallDistID: '',
      rainfallCellID: 0,
      // static for now
      stormFrequency: 'YR_1, YR_2, YR_5, YR_10, YR_25, YR_50, YR_100, YR_200, YR_500',
      rdt_smoothing: true,
      // prec1: 0,
      // prec2: 0,
      // prec5: 0,
      // prec10: 0,
      // prec25: 0,
      // prec50: 0,
      // prec100: 0,
      lulc_h: [],
      note: '',
      metadata: '',
    };
    this.rainfallDischargeTable = [
      { frequency: 0, rainfall: 0, peakFlow: 0, runoff: 0, selected: false },
      { frequency: 0, rainfall: 0, peakFlow: 0, runoff: 0, selected: false },
      { frequency: 0, rainfall: 0, peakFlow: 0, runoff: 0, selected: false },
      { frequency: 0, rainfall: 0, peakFlow: 0, runoff: 0, selected: false },
      { frequency: 0, rainfall: 0, peakFlow: 0, runoff: 0, selected: false },
      { frequency: 0, rainfall: 0, peakFlow: 0, runoff: 0, selected: false },
      { frequency: 0, rainfall: 0, peakFlow: 0, runoff: 0, selected: false },
      { frequency: 0, rainfall: 0, peakFlow: 0, runoff: 0, selected: false },
      { frequency: 0, rainfall: 0, peakFlow: 0, runoff: 0, selected: false },
    ];
    this.rainfallPlotData = [];
    this.dlUrls = [];
    this.rcnTable = [];
    this.unitsAreAcres = true;
    this.landUseCategorySelection = 'FDUA';
    this.rcnData = [];
  }
}
